import { Apple } from "lucide-react";
import { analytics } from "@heycatch/sdk";
import { SITE } from "../../config/site";

export const AppStoreBadge = ({ dark = true, testId = "app-store-badge" }) => (
  <a
    href={SITE.appStoreUrl}
    target="_blank"
    rel="noopener noreferrer"
    data-testid={testId}
    onClick={() => analytics.trackEvent("app_store_click", { location: testId })}
    className={`inline-flex items-center gap-3 rounded-full px-6 py-3.5 shadow-[0_8px_24px_rgba(0,0,0,0.10)] transition-all duration-300 hover:scale-[1.03] hover:shadow-[0_16px_32px_rgba(0,0,0,0.16)] ${
      dark ? "bg-neutral-900 text-white" : "bg-white text-neutral-900"
    }`}
  >
    <Apple className="h-6 w-6 fill-current" aria-hidden="true" />
    <span className="flex flex-col leading-tight text-left">
      <span className="text-[10px] uppercase tracking-[0.18em] opacity-70">Download on the</span>
      <span className="text-base font-semibold tracking-tight">App Store</span>
    </span>
  </a>
);
